import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
export default function mapNodeToFragment(node, index) {
    return _jsx(Fragment, { children: node }, index);
}
//# sourceMappingURL=map-node-to-fragment.js.map